import React from 'react';

import TabLayout, {TabLayoutProps} from 'ui-library/TabLayout';

import {useAnalyticsDashboardContext} from './analytics-dashboards/details/AnalyticsDashboardDetailsContext';

export default function AnalyticsTabSkeleton({
  children,
  ...restProps
}: Omit<TabLayoutProps, 'backgroundColor' | 'isHeaderFrozen'>): JSX.Element {
  const {
    theme: {dashboardBackgroundColor},
  } = useAnalyticsDashboardContext();
  return (
    <TabLayout {...restProps} isHeaderFrozen={true} backgroundColor={dashboardBackgroundColor}>
      {children}
    </TabLayout>
  );
}
